// Villager jobsites (MB.7). PURE (ENG-1). An unemployed villager that reaches an
// unclaimed workstation takes up its profession. This owns the workstation →
// profession mapping; the host does the range scan + one-villager-per-site claim
// and retypes the entity (gaining a trade table). Persistence of the claim rides
// on the entity's durable data (see EntitySystem toJSON/loadJSON).

/** Workstation block → the villager profession (mob type) it grants. */
export const WORKSTATION_PROFESSION: Readonly<Record<string, string>> = {
  composter: 'farmer',
};

/** The profession a workstation grants, or null if the block isn't one. */
export function professionFor(workstation: string): string | null {
  return WORKSTATION_PROFESSION[workstation] ?? null;
}

/** Whether a block is a claimable villager workstation. */
export function isWorkstation(block: string): boolean {
  return block in WORKSTATION_PROFESSION;
}
